'use client';

import { ElementType, useEffect, useMemo, useState } from 'react';

import { WITH_LINK_SANITIZE_CONFIG } from '../sanitizer';

import { useSavedUtmParams, useUtmProduct } from '@/shared/hooks';
import { applyUtmParamsToHtml } from '@/shared/utils/utmLinks';

interface UtmHtmlProps {
  html?: string;
  as?: ElementType;
  className?: string;
  id?: string;
}

export const UtmHtml = ({
  html = '',
  as: Tag = 'div',
  className,
  id,
}: UtmHtmlProps) => {
  const [cleanHtml, setCleanHtml] = useState('');

  const utmParams = useSavedUtmParams();
  const utmProduct = useUtmProduct();
  const htmlWithUtm = useMemo(
    () => applyUtmParamsToHtml(html, utmParams, utmProduct),
    [html, utmParams, utmProduct],
  );

  useEffect(() => {
    const sanitizeContent = async () => {
      const DOMPurify = (await import('dompurify')).default;
      const clean = DOMPurify.sanitize(htmlWithUtm, WITH_LINK_SANITIZE_CONFIG);

      setCleanHtml(clean);
    };

    sanitizeContent();
  }, [htmlWithUtm]);

  return (
    <Tag
      id={id}
      className={className}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};
